import { render, staticRenderFns } from "./SourcesModal.vue?vue&type=template&id=99eb9716&"
import script from "./SourcesModal.vue?vue&type=script&lang=ts&"
export * from "./SourcesModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports